type RuntimeConfig = {
  REACT_APP_API_BASE_URL?: string;
  SHOW_DEBUG_JSON?: boolean;
};

type AppConfig = {
  REACT_APP_API_BASE_URL: string;
  SHOW_DEBUG_JSON: boolean;
};

const resolveDefaults = (): AppConfig => {
  if (typeof window === "undefined") {
    return {
      REACT_APP_API_BASE_URL: "https://api.laceai.run",
      SHOW_DEBUG_JSON: false,
    };
  }

  const host = window.location?.hostname ?? "";
  const isLocalhost = host === "localhost" || host === "127.0.0.1" || host === "::1";

  return {
    REACT_APP_API_BASE_URL: isLocalhost
      ? "http://localhost:8787"
      : "https://api.laceai.run",
    SHOW_DEBUG_JSON: isLocalhost,
  };
};

const defaults = resolveDefaults();
const runtimeConfig: RuntimeConfig =
  (typeof window !== "undefined" ? (window as any).__CONFIG__ : null) || {};

export const config: AppConfig = {
  REACT_APP_API_BASE_URL:
    runtimeConfig.REACT_APP_API_BASE_URL || defaults.REACT_APP_API_BASE_URL,
  SHOW_DEBUG_JSON:
    typeof runtimeConfig.SHOW_DEBUG_JSON === "boolean"
      ? runtimeConfig.SHOW_DEBUG_JSON
      : defaults.SHOW_DEBUG_JSON,
};
